export const subArrsByKey = <T>(array: T[], key: keyof T) => {
  return array
    .reduce<number[]>((prev, curr, index, arr) => {
      //bounds
      return !index ? prev : curr[key] !== arr[index - 1][key] ? [...prev, index] : [...prev];
    }, [])
    .reduce<T[][]>((prev, curr, index, arr) => {
      //slice initial array along the bounds
      return index + 1 === arr.length
        ? [...prev, array.slice(arr[index - 1], curr), array.slice(curr)]
        : [...prev, array.slice(index !== 0 ? arr[index - 1] : 0, curr)];
    }, []);
};
